module.exports = __webpack_public_path__ + "media/images/makehub_joyce-2f247b576eafd09715d9bbba1253c65a.png";